import { ReactNode } from 'react';

import { PriceDetailItem } from './PriceDetailItem';

export type PriceDetailItemType = {
  description: string;
  value: ReactNode;
  isStrong?: boolean;
};

type Props = {
  items: PriceDetailItemType[];
  isLoading?: boolean;
};

export const PriceDetails = ({ items, isLoading }: Props) => {
  return (
    <div className="flex flex-col gap-2">
      {items.map((item) => {
        return (
          <PriceDetailItem
            description={item.description}
            value={isLoading ? <span className="skeleton-text w-16" /> : item.value}
            isStrong={item.isStrong}
          />
        );
      })}
    </div>
  );
};
